<template>
<div id="intro">
  <div class="sectionIntro" v-if="filteredVersionList.length">
    <div class="sectionBack">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <router-link class="breadcrumb-item"
          :to="{path: '/avatamsaka/chooseIntro'}" v-if="filteredVersionList.length">
            {{$t('avatamsaka.intro.title')}}
          </router-link>
          <li class="breadcrumb-item active" aria-current="page" v-if="filteredVersionList.length">
            {{$t('avatamsaka.introPage.introPageTitle')}}
          </li>
        </ol>
      </nav>
    </div>
    <div class="introContent" v-if="!verIdIs01">
      <div class="introCover">
        <img class="w-100" :src="versionList[versionId-1].bookCover">
      </div>
      <div class="introTitle">
        <h1>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.type[${versionId-1}].text`)
          })}}
        </h1>
        <span>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.authorType[${versionId-1}].text`)
          })}}
        </span>
        <p>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.introPageShortType[${versionId-1}].text`)
          })}}
        </p>
      </div>
    </div>

    <div class="introContentV1" v-if="verIdIs01" >
      <div class="introCover">
        <img class="w-100" :src="versionList[0].bookCover">
      </div>
      <div class="introTitle">
        <h1>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.type[${versionId-1}].text`)
          })}}
        </h1>
        <span>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.authorType[${versionId-1}].text`)
          })}}
        </span>
        <p>
          {{$t('avatamsaka.versions.version', {
            'noticeType': $t(`avatamsaka.versions.introPageShortType[${versionId-1}].text`)
          })}}
          <!-- <br v-if="verIdIs01" /><b-button @click="getDergeIntroPath()" v-if="verIdIs01">
            {{$t('avatamsaka.dergePage.aboutDerge')}}
          </b-button> -->
        </p>
      </div>
    </div>

  </div>

  <div class="detailArea">

    <div class="detailContent">
      <div class="detailTitle" v-if="verIdIs01">
        {{$t('avatamsaka.introPage.introPage', {
          'noticeType': $t(`avatamsaka.introPage.introductionTypeTitle[${versionId-1}].text`)
        })}}
      </div>
      <div class="detailStory">
        <p v-html="$t('avatamsaka.introPage.introPage', {
            'noticeType': $t(`avatamsaka.introPage.introductionType[${versionId-1}].text`)
          })">
        </p>
      </div>
    </div>
  </div>

  <div class="translatorArea">
    <div class="translatorContent">
      <p v-html="$t('avatamsaka.introPage.introPage', {
          'noticeType': $t(`avatamsaka.introPage.translatorType[${versionId-1}].text`)
        })">
      </p>
    </div>
    <div class="translatorImg" v-if="versionList[versionId-1]">
      <img :src="versionList[versionId-1].introPageTranslator">
    </div>
  </div>
  <div class="storyTitle" v-if="verIdIs01n2">
    {{$t('avatamsaka.introPage.introPage', {
      'noticeType': $t(`avatamsaka.introPage.storyTitleType[${versionId-1}].text`)
    })}}
  </div>
  <div class="storyArea" >
    <div class="storyContent" v-if="verIdIs01n2">
      <img :src="versionList[versionId-1].introPageStory"
      v-if="versionList[versionId-1].id !==1 && versionList[versionId-1].id !== 2">
    <p v-html="$t('avatamsaka.introPage.introPage', {
          'noticeType': $t(`avatamsaka.introPage.storyType[${versionId-1}].text`)
        })">
      </p>
    </div>
  </div>

  <div class="storyTitle ">
    {{$t('avatamsaka.introPage.introPage', {
      'noticeType': $t(`avatamsaka.introPage.categoryTitleType[${versionId-1}].text`)
    })}}
  </div>

  <div class="categoryArea" v-if="!verIdIs01">

      <p class="categoryContent" v-html="$t('avatamsaka.introPage.introPage', {
          'noticeType': $t(`avatamsaka.introPage.categoryType01[${versionId-1}].text`)
        })">
      </p>
      <p class="categoryContent" v-html="$t('avatamsaka.introPage.introPage', {
          'noticeType': $t(`avatamsaka.introPage.categoryType02[${versionId-1}].text`)
        })">
      </p>
  </div>


  <div class="noThisVer" v-if="!filteredVersionList.length">
    {{$t('avatamsaka.other.chooseOtherVer')}}
    <ul>
      <li @click="getVersionPath(1)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[0].text`)
        })}}
      </li>
      <li @click="getVersionPath(2)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[1].text`)
        })}}
      </li>
      <li @click="getVersionPath(3)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[2].text`)
        })}}
      </li>
      <li @click="getVersionPath(4)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[3].text`)
        })}}
      </li>
      <li @click="getVersionPath(5)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[4].text`)
        })}}
      </li>
    </ul>
  </div>
</div>
</template>

<script>

export default {
  name: 'intro',
  data() {
    return {
    };
  },
  computed: {
    verIdIs01() {
      return (this.$route.params.vid === '1');
    },
    verIdIs01n2() {
      if (this.$route.params.vid === '2' || '1') {
        return ('false');
      }
      return ('true');
    },
    versionId() {
      return this.$route.params.vid;
    },
    versionList() {
      return this.$store.state.versionList;
    },
    sutraList() {
      return this.$store.state.sutraList;
    },
    versions() {
      return this.$store.getters.versions;
    },
    filteredVersionList() {
      let versionList = [...this.versionList];
      const nowVersionId = Number(this.versionId);

      if (nowVersionId !== '') {
        versionList = versionList.filter(item => item.id === nowVersionId);
      }

      return versionList;
    },
    filteredSutraVersionList() {
      let sutraList = [...this.filteredVersionList];

      if (sutraList.length !== 0) {
        sutraList = this.filteredVersionList[0].contents;
      }
      return sutraList;
    },
  },
  methods: {
    getDergeIntroPath() {
      this.$router.push({
        path: '/avatamsaka/intro/1/DergeParkhang',
      });
    },
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
    getSutraArticlePath(sutraId) {
      this.$router.push({
        name: 'article',
        params: {
          sid: sutraId,
          vid: this.$route.params.vid,
        },
      });
    },
    getSutraContraPath(sutraId) {
      this.$router.push({
        name: 'contra',
        params: {
          sid: sutraId,
          vid: this.$route.params.vid,
        },
      });
    },
  },
  mounted() {
    this.$store.dispatch('getVersionList');
    this.$store.dispatch('getSutraList');
  },
};
</script>

<style lang="scss" scoped>

#intro {

  line-height: 2em;

  p{
    white-space: pre-line;
  }

  .noThisVer {
    padding: 45px;
    font-size: 1.2em;
    ul {
      list-style: none;
      li {
        margin: 10px;
        padding: 5px;
        background: rgb(221, 242, 219);
      }
      li:hover {
        cursor: pointer;
        background: rgb(241, 235, 178);
      }
    }
  }

  .sectionIntro {
      display: flex;
      padding-bottom: 0px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      height: 60%;
      background: #d9e2c4;
      position: absolute;
      .breadcrumb {
        background: transparent;
        .breadcrumb-item{
          color: #4C4A4A;
        }
      }
    }

    .sectionBack::after {

        border-top: 20vh solid #d9e2c4;
        border-right: 50vw solid transparent;
        border-left: 50vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;

    }


    .introContent {
      max-width: 1200px;
      position: sticky;
      flex: 1;
      margin: 60px auto;
      margin-bottom: 0px;
      padding: 20px;
      padding-bottom: 0px;
      text-align: left;
      align-self: center;
      display: flex;
      .introCover {
        flex: initial;
        align-items: center;
        padding-top: 60px;
        img {
          max-width: 350px;
          min-width: 20vw;
          width: 100%;
          float: right;
          padding-right: 60px;
        }
      }
      .introTitle {
        padding: 60px;
        span {
          color: #3f65dc8c;
          font-weight: bolder;
        }
        p {
          position: relative;
          padding: 20px;
          padding-left: 0px;
          font-size: 1.2em;
        }
      }
    }

    .introContentV1 {
      position: sticky;
      flex: 1;
      margin: 60px;
      margin-left: calc(1.8em+20px);
      margin-right: calc(1.8em+20px);
      margin-bottom: 0px;
      padding: 20px 0px;
      padding-bottom: 0px;
      text-align: left;
      align-self: center;
      display: flex;
      .introCover {
        flex: initial;
        align-items: center;
        padding-top: 60px;
        img {
          min-width: 25vw;
          width: 100%;
          float: right;
          padding-right: 60px;
        }
      }
      .introTitle {
        padding: 60px;
        padding-right: 0px;
        span {
          color: #3f65dc8c;
          font-weight: bolder;
        }
        p {
          position: relative;
          padding: 20px;
          padding-right: 0px;
          padding-left: 0px;
          font-size: 1.2em;
        }
      }
    }

    @media (max-width: 768px) {

        display: block;
        flex-direction: row;

        .introCover, .introContent {
          clear: both;
          display: block;
          width: 100%;
          flex: none;
          margin: 0px;
          padding: 40px;
        }

        .introCover {
          position: relative;
          margin: 0;
          img {
            width: 100%;
          }
        }

        .introContent {
          .introTitle {
            padding: 1em;
            margin-bottom: 4em;
          }
        }
    }
  }

  .detailArea {
    text-align: left;

    .detailContent {
      margin: 1.8em;
      margin-top: 0;

      div {
        padding: 20px;
        .title {
          font-size: 1.8em;
          padding: 0px;
          button {
            background: #d9e2c4;
            color: rgb(45, 42, 43);
            border: 1px solid #c2cbae;
          }
          img {
            background: red;
          }
        }
      }
         .detailTitle {
            clear: both;
            text-align: center;
            padding-top: 0px;
            margin-bottom: 0px;
            padding-bottom: 0px;
            width: 100%;
            font-size: 2em;
            font-weight: 500;
          }
          .detailStory {
            clear: both;
            display: block;
            p {
              margin-top: -1em;
            }
          }
    }
  }

  .translatorArea {
    text-align: left;
    display: flex;
    margin: 1.8em;
    align-items: center;
    .translatorContent {
      flex: 1;
      background: #ecf0e5;
      color: rgb(45, 42, 43);
      border: 15px double #9da48d;
      margin: 5px 1.5em;
      padding: 2em;
    }
    .translatorImg {
      flex: initial;
      margin: 0px 1.5em 0px 0px;
      img {
        max-width: 100%;
      }
      max-width: 400px;
    }
  }

  .storyTitle {
    clear: both;
    text-align: center;
    padding-top: 20px;
    width: 100%;
    font-size: 2em;
    font-weight: 500;
  }
  .storyArea {
    text-align: left;
    margin: 0px 1.8em 1.8em 1.8em;
    .storyContent {
      margin: 5px 1.5em;
      padding: 2em;
      img {
        margin: 32px 1.5em 16px 0px;
        max-width: 500px;
        max-height: 400px;
        float: left;
      }
      p {
        >>> ul {
          li {
            margin-bottom: 1em;
          }
        }
        >>> h3 {
          font-weight: bolder;
        }
        >>> h4 {
          font-weight: bolder;
        }
      }
    }
  }

  .categoryArea {
    clear: both;
    text-align: left;
    margin: 1.8em;
    display: flex;

    .categoryContent {
      margin: 5px 1.5em;
      padding: 2em;
      flex: 1;
    }
    .categoryContent:nth-child(2) {
      border-left: 2px solid #4f5442;
    }
  }

  @media (max-width: 768px) {

    h1 {
      font-size: 1.4em;
    }
    >>>h3 {
      font-size: 1.12em;
      font-weight: bold;
    }
    span {
      font-size: 1em;
    }
    .sectionIntro {
      background: #d9e2c4;
      .sectionBack {
        position: initial;
        text-align: left;
        margin-bottom: 0px;
        .breadcrumb {
          margin-bottom: 0px;
        }
      }

      .sectionBack::after {
        z-index: -2;
      }

      .introContent {
        position: relative;

        padding: 0px;

        .introCover {
          img {
            padding: 1em;
            padding-top: 0px;
          }
        }

        .introTitle {
          text-align: center;
          padding-bottom: 0px;
          span {
            color: #194b49;
            font-weight: 100;
          }
          p {
            position: relative;
            padding: 0;
            font-size: 1em;
          }
        }
      }
      .introContentV1 {
        display: flex;
        flex-direction: column;
        margin: 1em;
        .introCover {
          padding: 0px;
          img {
            margin-top: -4em;
            padding: 2em;
          }
        }
        .introTitle {
          padding: 0px;
          margin-top: -2em;
          p {
            font-size: 1em;
          }
        }
      }
    }

    .detailArea {
      .detailContent {
        margin: 1em;
        display: flex;
        flex-direction: column;
        .detailTitle {
          font-size: 1.4em;
          line-height: 1.5em;
          padding: 0px;
        }
        .detailStory {
          padding: 0px;
          padding-top: 2em;
          p {
            margin: 0px;
            font-size: 1em;
          }
        }
      }
    }

    .translatorArea {
      flex-direction: column;
      margin: 1em;
      .translatorContent {
        margin: 0;
        width: 100%;
        padding: 1em;
        padding-top: 0px;
      }
      .translatorImg {
        margin: 0px;
        margin-top: 1em;
      }
    }

    .storyTitle  {
      padding: 0.9em;
      padding-bottom: 0;
      font-size: 1.3em;
    }

    .storyArea {
      margin: 1em;
      .storyContent {
        margin: 0;
        padding: 0;
        img {
          max-width: 100%;
          margin: 0px;
        }
        p {
          margin-top: 0px;
        }
      }
    }

    .categoryArea {

      flex-direction: column;
      margin: 1em;
      margin-top: 0px;

      .categoryContent {
        margin: 0;
        padding: 0;
      }

      .categoryContent:nth-child(2) {
        border: none;
      }
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/components/Intro.vue